import React from 'react'
import styled from 'styled-components' 
import { useDispatch, useSelector } from 'react-redux'
import moment from 'moment-timezone'
import { useHistory } from "react-router";
import Measure from 'react-measure'

import { TextField, Modal, Animation, ListTile, Spinner, Button } from 'components';
import { ItemBlock, ItemModal, PageBlock } from 'features'
import { AnimatePresence, AnimateSharedLayout, motion } from 'framer-motion';
import { FaSearch } from 'react-icons/fa'

import * as api from 'api'
import * as actionCreators from 'store/actions'
import { Data, Item, Page } from 'schema'
import { moduleContext, commandContext, pageContext, accessContext } from 'context';
import { queryToDate } from 'utils'

const Container = styled.div`
    background-color: var(--primary-color);
    border-radius: 5px;
    width: 80vw;
    max-width: 40rem;
    cursor: auto;
    /* padding: 0.5rem; */
    display: flex;
    flex-direction: column;
    overflow: hidden;
    position: relative;
    /* top: 20vh; */
    top: 0;
    border: 1px solid var(--secondary-color);
    box-shadow: 0px 2px 1px -1px var(--primary-accent2-color),
                0px 1px 1px 0px var(--primary-accent2-color), 
                0px 1px 3px 0px var(--primary-accent2-color);
`

const Header = styled.div`
    display: grid;
    grid-template-columns: auto 1fr auto;
    grid-column-gap: 0.5rem;
    /* display: flex; */
    align-items: center;
    border-bottom: ${props => props.open && '1px solid var(--secondary-color)'};
    padding-bottom: ${props => props.open && '0.5rem'};
    padding: 0.5rem;
    /* padding-left: ${props => props.open && '0.5rem'}; */
`

const Body = styled.div`
    padding: 1rem 0.5rem;
    width: 100%;
    height: min-content;
    max-height: 60vh;
    display: flex;
    flex-direction: column;
    background-color: var('--secondary-color');
    overflow-y: auto;
    padding: 0.5rem;
    /* height: 40vh; */
`

const Title = styled.div`
    font-weight: bolder;
    /* text-transform: uppercase; */
    /* border-bottom: 1px solid var(--primary-accent-color); */
    font-size: 0.8rem;
    padding: 0 0.5rem 0 0.5rem;
    margin-top: ${props => props.marginTop};
    color: var(--secondary-accent-color);
`

const Placeholder = styled.div`
    color: var(--secondary-accent-color);
    margin: 0.5rem;
`

const Block = styled.div`
    border: ${props => `2px solid ${props.focus ? 'var(--focus-color)' : 'transparent'}`};
    border-radius: 5px;
`

const moduleStyle = {
    padding: '0.5rem 0.5rem',
    backgroundColor: 'var(--primary-color)'
    // border: '2px solid transparent'
}

const selectedModuleStyle = {
    padding: '0.5rem 0.5rem',
    backgroundColor: 'var(--primary-color)'
    // border: '2px solid var(--focus-color)'
}

const Search = props => {
    const {

    } = props
    const debug = false
    const start_time = performance.now()
    const dispatch = useDispatch()
    const history = useHistory()
    const [value, setValue] = React.useState('')
    const [results, setResults] = React.useState({}) // { key: { title: xxx, results: {}, blocks: [] } }
    const [limit, setLimit] = React.useState(0)
    const [displayLimit, setDisplayLimit] = React.useState(50)
    const [showSpinner, setSpinner] = React.useState(false)
    const [focus, setFocus] = React.useState(-1)
    const layoutRef = React.useRef(null)
    const optionsRef = React.useRef([])
    const [height, setHeight] = React.useState(0)

    const data = useSelector(state => state.db.present.data && state.db.present.data.toJS())
    const user = useSelector(state => state.auth.user)
    const loadedDates = useSelector(state => state.db.present.loadedDates)

    React.useEffect(() => {
        const cached = getCachedResults()
        getQueryResults(cached)
        console.log(`[Search] ${((performance.now() - start_time)/1000).toFixed(2)}s`)
    }, [value])

    //////////////////
    // Search logic //
    //////////////////
    const getCachedResults = () => {
        // if(!value) { return }
        setSpinner(true)
        let updatedResults = {}
        const searchValue = value.toLowerCase()
        let n = 0
        let accessProps = {}
        
        // 1. Fuzzy matching
        const output = new Data(data, user).search(searchValue)
        const searchResults = output['results']
        const dateRef = output['date']

        // 2. Page results
        if(searchResults['pages'].length > 0){
            updatedResults['pages'] = { title: 'Pages', raw: [] }
            searchResults['pages'].forEach(page => {
                updatedResults['pages']['raw'].push({ 
                    id: page['pageID'], 
                    value: page,
                    type: 'page',
                    index: n,
                    onSelect: () => {changePageHandler(page.pageID, pageContext.TYPES.PAGES)},
                    block: <PageBlock key={page.pageID} page={page} disableButtons
                                style={{backgroundColor: 'var(--primary-color)', fontWeight: 'normal'}} border
                                onSelect={() => {changePageHandler(page.pageID, pageContext.TYPES.PAGES)}}/>
                })
                n+=1
            })
        }

        // 3. Commands
        if(searchResults['commands'].length > 0){
            updatedResults['commands'] = { title: 'Commands', raw: [] }
            
            searchResults['commands'].forEach(command => {
                Object.keys(commandContext).includes(command) && 
                updatedResults['commands']['raw'].push({ 
                    id: command, 
                    value: command, 
                    type: 'command', 
                    index: n,
                    onSelect: () => {commandContext[command]['callback'] && commandContext[command]['callback']()},
                    block:  <ListTile text={commandContext[command]['title']}
                                icon={commandContext[command]['icon']}
                                styles={moduleStyle}
                                onSelect={() => { commandContext[command]['callback'] && commandContext[command]['callback']()}}/>
                })
                n+= 1
            })
        }

        // 4. Access modules results
        if(searchResults['access'].length > 0){
            updatedResults['access'] = { title: 'Access', raw: []}

            searchResults['access'].forEach(module => {
                const pageType = user['activePageType']
                // Special date texts
                const timezone = user['timezone']
                accessProps = {
                    date: searchValue.includes('today') || searchValue.includes('upcoming') || searchValue.includes('calendar') || searchValue.trim().length === 0 ? moment().tz(timezone)
                        : searchValue.includes('yesterday') ? moment().tz(timezone).subtract({days: 1})
                        : searchValue.includes('tomorrow') ? moment().tz(timezone).add({days: 1})
                        : dateRef !== 'Invalid date' ? moment(dateRef).tz(timezone)
                        : null,
                }
                accessProps['range'] = (accessProps.date || dateRef) && 'day'
                const text = module === 'CALENDAR' && dateRef !== 'Invalid date' ? `Upcoming on ${dateRef}`
                            : moduleContext.MODULES[module]

                // Render blocks
                updatedResults['access']['raw'].push({ 
                    id: module, 
                    value: module, 
                    type: 'access', 
                    accessProps: module === 'CALENDAR' && accessProps,
                    index: n,
                    onSelect: () => {pageType === 'Pages' && dispatch(actionCreators.setAccess(true, accessContext[module]['value'], accessProps))},
                    block: <ListTile text={text}
                            icon={moduleContext.ICONS[module]}
                            styles={moduleStyle}
                            onSelect={() => pageType === 'Pages' && dispatch(actionCreators.setAccess(true, accessContext[module]['value'], accessProps))}/>
                })
                n+=1
            })
        }

        // 5. Modules results
        if(searchResults['modules'].length > 0){
            updatedResults['modules'] = { title: 'Modules', raw: [] }
            
            searchResults['modules'].forEach(module => {
                updatedResults['modules']['raw'].push({ 
                    id: module, 
                    value: module, 
                    type: 'module',
                    index: n,
                    onSelect: () => changePageHandler(module, pageContext.TYPES.MODULES),
                    block: <ListTile text={moduleContext.MODULES[module]}
                            icon={moduleContext.ICONS[module]}
                            styles={moduleStyle}
                            onSelect={() => changePageHandler(module, pageContext.TYPES.MODULES)}/>
                })
                n+=1
            })
        }

        // 6. Item results
        const titles = {
            scheduled: 'Scheduled',
            created: 'Created',
            completed: 'Completed',
            items: 'Items'
        }
        Object.values(['scheduled', 'created', 'completed', 'items']).forEach(category => {
            if(searchResults[category].length > 0){
                updatedResults[category] = { title: titles[category], raw: [] }

                searchResults[category].forEach(item => {
                    updatedResults[category]['raw'].push({ 
                        id: item['itemID'], 
                        value: item, 
                        type: 'item',
                        index: n,
                        onSelect: () => {dispatch(actionCreators.setModal(<ItemModal itemID={item['itemID']}/>, `${item.itemID}_ItemModal`))},
                        block: <div onClick={() => dispatch(actionCreators.setModal(<ItemModal itemID={item['itemID']}/>, `${item.itemID}_ItemModal`))}>
                            <ItemBlock 
                                    key={item.itemID} 
                                    itemID={item['itemID']} 
                                    disableButtons pageName type='SEARCH' disableBottomBorder
                                    onSelect={() => {dispatch(actionCreators.setModal(<ItemModal itemID={item['itemID']}/>, `${item.itemID}_ItemModal`))}}
                                    />
                        </div>
                    })
                    n+=1
                })
            }
        })

        setFocus(-1)
        setResults(updatedResults)
        setLimit(n)
        debug && console.log('[getCachedResults]',{ value, dateRef, search: searchResults, ouput: updatedResults })
        return updatedResults
    }

    const getQueryResults = async (cached) => {
        const searchValue = value.toLowerCase()

        // 1. Find similar tags
        const tags = Object.values(data['tags']).filter(tag => tag['content'].toLowerCase().includes(value))
        const tagIDs = tags.map(tag => tag['tagID'])

        // 2. Check if date
        let queryDate = queryToDate(value, user['timezone'])
        if(queryDate && queryDate['$gte']){
            if(loadedDates.includes(moment(queryDate['$gte']).format('YYYY-MM-DD'))){
                queryDate = null
            }
        }

        // 3. Query data
        let updatedData = {...data}
        let queryData = { pages: {}, items: {} }
        if(value.length > 0){
            const searchRes = await Promise.all([
                // Include page query once collaboration/sharing is released
                false && api.getPages({ filters: { 
                    createdBy: user['uid'], 
                    page_name: `LIKE_${value}` 
                }})
                .then(pageRes => { 
                    Object.values(pageRes.data['pages']).forEach(page => {
                        updatedData['pages'][page['_id']] = new Page(page)
                        queryData['pages'][page['_id']] = new Page(page)
                    })
                    debug && console.log('[getResults] Got pages', pageRes.data['pages'])
                    return pageRes
                }),
                api.getItems({ 
                    logic: 'OR',
                    userID: user['uid'],
                    filters: { 
                        plainText: `LIKE_${value}`,
                        tags: tagIDs,
                        start_date: queryDate,
                        end_date: queryDate,
                    }
                })
                .then(itemRes => {
                    Object.values(itemRes.data['items']).forEach(item => {
                        updatedData['items'][item['_id']] = new Item(item)
                        queryData['items'][item['_id']] = new Item(item)
                    })
                    debug && console.log('[getResults] Got items', itemRes.data['items'])
                    return itemRes
                })
            ])
        }

        // 4. Update results
        let updatedResults = {...cached}
        let shouldUpdate = false
        for (const [key, value] of Object.entries(queryData)) {
            const existing = updatedResults[key] ? updatedResults[key]['raw'].map(x => x['id']) : []
            Object.values(value).forEach(block => {
                if(!existing.includes(block['_id'])){
                    shouldUpdate = true
                    
                    switch(key){
                        case 'items':
                            if(!updatedResults[key]){
                                updatedResults[key] = { title: 'Items', raw: [] }
                            }
                            updatedResults['items']['raw'].push({ 
                                id: block['itemID'], 
                                value: block, 
                                type: 'item',
                                onSelect: () => {dispatch(actionCreators.setModal(<ItemModal itemID={block['itemID']}/>, `${block.itemID}_ItemModal`))},
                                block: <div onClick={() => {dispatch(actionCreators.setModal(<ItemModal itemID={block['itemID']}/>, `${block.itemID}_ItemModal`))}}>
                                    <ItemBlock key={block.itemID} itemID={block['itemID']} disableButtons pageName type='SEARCH' disableBottomBorder
                                            onSelect={() => {dispatch(actionCreators.setModal(<ItemModal itemID={block['itemID']}/>, `${block.itemID}_ItemModal`))}}/>
                                </div>
                            })
                            break
                        case 'pages':
                            break
                    }
                }
            })
        }

        // 5. Recalculate index
        if(shouldUpdate){
            let n = 0
            for (const [category, output] of Object.entries(updatedResults)) {
                output['raw'].forEach((block, index) => {
                    updatedResults[category]['raw'][index]['index'] = n
                    n+=1
                })
            }
            setFocus(-1)
            setResults(updatedResults)
            setLimit(n)
            dispatch(actionCreators.updateData(updatedData))
        }
        setSpinner(false)
        debug && console.log('[getQueryData]', { queryDate, tagIDs, results: updatedResults })
    }

    //////////////
    // Handlers //
    //////////////
    const onKeyDown = (event) => {
        const keyCode = event.keyCode
        if(![13,27,38,40].includes(keyCode)){ return }
        event.preventDefault()

        switch(keyCode) {
            case 38:
                arrowHandler('up')
                break
            case 40:
                arrowHandler('down')
                break
            case 27:
                dispatch(actionCreators.setModal(null,null))
                break
            case 13:
                let blocks = []
                Object.values(results).forEach(category => {
                    blocks.push(...category['raw'])
                })
                blocks[focus] && blocks[focus]['onSelect'] && blocks[focus]['onSelect']()
                break
        }
    }

    const arrowHandler = (direction) => {
        let newFocus = direction === 'down' ? focus + 1 : focus - 1
        if(newFocus >= limit){
            newFocus = 0
        } else if (newFocus <= -1){
            newFocus = limit - 1
        }
        setFocus(newFocus)

        // Scroll if need
        if(layoutRef.current){
            const layoutRect = layoutRef.current.getBoundingClientRect()
            const rects = optionsRef.current.map(ref => ref && ref.getBoundingClientRect())
            const bottoms = optionsRef.current.map(ref => ref && ref.getBoundingClientRect()['bottom'] - layoutRect['y'])
            const tops = optionsRef.current.map(ref => ref && ref.getBoundingClientRect()['top'] - layoutRect['y'])
            const heights = optionsRef.current.map(ref => ref && ref.getBoundingClientRect()['height'])
            let scrollTo = -1
            if(newFocus === limit - 1){
                // scrollTo = layoutRect['height'] + 1000
                scrollTo = layoutRef.current.scrollHeight
            } else if (newFocus === 0) {
                scrollTo = 0
            } else {
                // Old logic [not very good]
                // console.log(bottoms[newFocus] > layoutRect['height'], tops[newFocus] < 0 )
                // scrollTo = bottoms[newFocus] > layoutRect['height'] ? tops[newFocus] + layoutRef.current.scrollTop
                //         : tops[newFocus] < 0 ? Math.abs(bottoms[newFocus]) + Math.abs(tops[newFocus])
                //         : -1

                // New logic
                scrollTo = bottoms[newFocus] > layoutRect['height'] ? layoutRef.current.scrollTop + heights[newFocus]
                            : tops[newFocus] < 0 ? layoutRef.current.scrollTop - heights[newFocus]
                            : -1 
            } 
            scrollTo > -1 && layoutRef.current.scrollTo({left: 0, top: scrollTo, behavior: 'smooth'})
        }
    }

    const changePageHandler = (pageID, type) => {
        let updatedUser = {...user}
        updatedUser['activePageID'] = pageID
        updatedUser['activePageType'] = type
        dispatch(actionCreators.updateUser(updatedUser))
        dispatch(actionCreators.setModal(null,null))
        history.push(pageID.toLowerCase())
        window.scrollTo(0,0)
    }

    return (
        <Modal x='50%' y='20%' onClose={() => dispatch(actionCreators.setModal())}>
            <Container>
                <Header open={value && value.length > 0}>
                    {showSpinner ? <Spinner/> : <FaSearch style={{color: 'var(--secondary-accent-color)', fontSize: '1rem'}}/>}
                    <TextField value={value} onChange={(text) => setValue(text)} onKeyDown={onKeyDown}
                        type='single' focus addDelay delayDuration={500}
                        placeholder='Search...' style={{width: '100%'}}/>
                </Header>
                
                <AnimatePresence key={value}>
                    <motion.div key={value}
                        initial="collapsed" animate="open" exit="collapsed"
                        style={{overflow: 'hidden' }}
                        transition={{ duration: 0.3 }}
                        variants={{
                            // open: { height: 'auto', opacity: 1 },
                            // collapsed: { height: height, opacity: 0 }
                            open: { opacity: 1, translateY: 0, originY: 0 },
                            collapsed: { opacity: 0, translateY: -2, originY: 0 }
                        }}
                        onAnimationStart={() => {
                            debug && console.log('[ANIMATION_START]', { height })
                        }}
                        onAnimationComplete={() => {
                            if(layoutRef.current){
                                const newHeight = layoutRef.current.getBoundingClientRect()['height']
                                newHeight !== height && setHeight(newHeight)
                                debug && console.log('[ANIMATION_DONE]', { height: newHeight })
                            }
                        }}>
                        
                        {(value | Object.keys(results).length > 0) ?
                        <Body ref={layoutRef}>
                            {value && value.length > 0 && Object.keys(results).length === 0 ? <Placeholder>No matching results</Placeholder>
                            : Object.values(results).map((category, index) => {
                                return (
                                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                                        <Title marginTop={index !== 0 && '0.5rem'}>{category['title']}</Title>
                                        {category['raw'].map(raw => {
                                            if(raw['index'] <= displayLimit){
                                                return <Block focus={raw['index'] === focus}
                                                    ref={el => optionsRef.current[raw['index']] = el}>
                                                    {raw['block']}
                                                </Block>
                                            }
                                        })}
                                    </div>
                                )
                            })}
                            {displayLimit < limit && <Button text='Show more' onSelect={() => setDisplayLimit(displayLimit + 50)} styles={{width: 'min-content', backgroundColor: 'var(--secondary-color)'}}/>}
                        </Body>
                        : null}
                    </motion.div>
                </AnimatePresence>
            </Container>
        </Modal>
    )
}

export default Search